const Site = () =>
  import(
    /* webpackChunkName: "site-generator-site-site" */ '@/pages/site-generator/site/site/index.vue'
  )

const CreateSite = () =>
  import(
    /* webpackChunkName: "site-generator-site-site" */ '@/pages/site-generator/site/site/create.vue'
  )

const EditSite = () =>
  import(
    /* webpackChunkName: "site-generator-site-site" */ '@/pages/site-generator/site/site/edit.vue'
  )

const DetailSite = () =>
  import(
    /* webpackChunkName: "site-generator-site-site" */ '@/pages/site-generator/site/site/detail.vue'
  )

export default {
  path: 'site',
  meta: {
    label: 'site',
    auth: 'site'
  },
  component: {
    name: 'Site',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'SiteSiteReport',
      path: '',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: Site
    },
    {
      name: 'SiteCreateSite',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: CreateSite
    },
    {
      name: 'SiteEditSite',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: EditSite,
      props: true
    },
    {
      name: 'SiteDetailSite',
      path: 'detail/:id',
      meta: {
        label: 'detail',
        auth: 'report'
      },
      component: DetailSite,
      props: true
    }
  ]
}
